export function dateButtonVariant(boolean) {
  if (boolean) {
    return 'info'
  }
  return 'danger'
}

export function isDatespanValid(start, end) {
  // after（期間の開始） よりも before（期間の終了）が前の場合はエラー。
  // 引数はどちらもDate型
  if (!start || !end) {
    return true
  }
  return start <= end
}

// 日付を整形する。文字列・date形に対応。
export function getArrangedDate(date) {
  if (!date) {
    return ''
  }
  // Date型の場合
  if (typeof date === 'object' && typeof date.getFullYear) {
    return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
  }
  // 文字列の場合
  if (typeof date === 'string') {
    var dateObject = new Date(date)
    return dateObject.getFullYear() + '年' + (dateObject.getMonth() + 1) + '月' + dateObject.getDate() + '日'
  }
  return ''
}
